import { IconInterface } from '../interfaces/icon.interface';

export const StatusClock = (props: IconInterface) => {
	const { color = '#454545', width = 16, height = 16 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="8" cy="8" r="7" stroke={color} />
			<path
				d="M8 5.19922V7.99922L9.75 9.74922"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
